import { NavLink, Outlet } from 'react-router-dom';
import { Moon, Sun, LogOut, BarChart3, Settings } from 'lucide-react';
import { useSession } from '../session';
import { useTheme } from '../lib/theme';
import { BrandMark } from './Brand';
import { Button } from './ui/button';
import { cn } from '../lib/utils';

const tabs = [
  { to: '/results', label: 'Results', Icon: BarChart3 },
  { to: '/manage', label: 'Manage', Icon: Settings },
];

export function OrganizerLayout() {
  const { logout } = useSession();
  const { dark, toggle } = useTheme();
  return (
    <div className="min-h-dvh">
      {/* brand banner — desktop */}
      <div className="hidden border-b bg-white md:block">
        <img
          src="/brand/aadpa-banner.png"
          alt="AADPA 9th Annual Conference — Embracing change for every mind"
          className="mx-auto h-16 w-auto max-w-full object-contain"
        />
      </div>
      <header className="sticky top-0 z-10 border-b bg-background/85 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2.5">
          <div className="flex items-center gap-2">
            <BrandMark className="size-8 ring-1 ring-border md:hidden" />
            <div className="font-bold tracking-tight">Organiser</div>
          </div>
          <nav className="flex items-center gap-1 rounded-lg bg-secondary p-1">
            {tabs.map(({ to, label, Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
                    isActive ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground',
                  )
                }
              >
                <Icon className="size-4" />
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-1">
            <Button variant="ghost" size="icon" onClick={toggle} aria-label="Toggle theme">
              {dark ? <Sun /> : <Moon />}
            </Button>
            <Button variant="ghost" size="icon" onClick={logout} aria-label="Logout">
              <LogOut />
            </Button>
          </div>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
